/* eslint-disable no-console */
/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-underscore-dangle */
import { useState, useEffect } from 'react';
import moment from 'moment';
import { toastSuccess, toastError } from '../../../../redux/actions/alertActions';
import examServices from '../../../../redux/services/examServices';
import groupServices from '../../../../redux/services/groupServices';
import elearningDetailsServices from '../../../../redux/services/elearningDetailsServices';
import companyServices from '../../../../redux/services/companyServices';

const useExam = (companyId, examList, updateExamData, semestersList) => {
  const [subjects, setSubjects] = useState([]);

  const withoutSubjectModalities = ['Sur table', 'Oral - cours en présentiel', 'Voie postale'];

  const getAcademicYearBounds = () => {
    const now = new Date();
    const currentYear = now.getFullYear();

    // Si on est avant septembre → l'année académique a commencé l'année précédente
    const startYear = now.getMonth() < 8 ? currentYear - 1 : currentYear;

    const yearBegin = new Date(startYear, 8, 1); // 1 septembre
    const yearEnd = new Date(startYear + 1, 8, 1); // 1 septembre année suivante

    return { yearBegin, yearEnd };
  };

  const isExamUsed = (subjectId) => {
    const { yearBegin, yearEnd } = getAcademicYearBounds();

    return examList.some((exam) => {
      const examBegin = new Date(exam.examBegin);
      const examEnd = new Date(exam.examEnd);

      return (
        exam.examSubject !== null
      && exam.examSubject?._id?.toString() === subjectId.toString()
      && examBegin <= yearEnd
      && examEnd >= yearBegin
      );
    });
  };

  useEffect(() => {
    if (subjects.length <= 0) {
      examServices.getExams()
        .then((subjectsArr) => {
          companyServices.getCompanyDataById(companyId)
            .then((companyData) => {
              const sanitizedSubjectsArr = [];
              subjectsArr.forEach((subject) => {
                if (subject.targets.includes(companyData.adminData.type)) {
                  sanitizedSubjectsArr.push(subject);
                }
              });
              setSubjects(sanitizedSubjectsArr);
            });
        });
    }
  }, []);

  const addExam = (form, catchUp) => {
    if (form.beginDate >= form.endDate) {
      toastError('La date de début de l\'examen doit être avant la date de fin.');
      return;
    }
    let subject = null;
    subjects.forEach((_subject) => {
      if (form.semester.examType === 1 || form.semester.examType === 2) {
        if (_subject.type === form.semester.examType
          && _subject.semester === form.semester.value
          && isExamUsed(_subject._id) === false) {
          subject = _subject;
        }
      } else if (_subject.type === form.semester.examType && _subject.semester === form.semester.value) {
        subject = _subject;
      }
    });
    if (subject === null && withoutSubjectModalities.includes(form.modality.value) === false) {
      toastError('Pas de sujets disponibles');
      return;
    }
    examServices.postExam(companyId, form.semester.value, {
      catchUp,
      duration: (form.modality.value === 'Oral Participation'
        || form.modality.value === 'Oral - cours en présentiel'
        || form.modality.value === 'Oral : Role Play'
        || form.modality.value === 'Oral : Case study'
        || (form.modality.value === 'Sur la plateforme' && form.semester.value === 6)
      )
        ? moment(new Date(form.endDate)).diff(moment(new Date(form.beginDate)), 'minutes')
        : form.duration.value,
      modality: form.modality.value,
      EWCorrect: form.modality.value !== 'Quiz automatisé' ? form.EWCorrect : false,
      examSubject: withoutSubjectModalities.includes(form.modality.value) ? null : subject._id,
      examBegin: form.beginDate,
      examEnd: form.endDate,
      deliveryDate: form.deliveryDate,
      status: {
        name: null,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    })
      .then(() => {
        updateExamData();
        toastSuccess('Examen ajouté.');
      })
      .catch(() => {
        toastError('Problème lors de l\'ajout de l\'examen.');
      });
  };

  const updateExam = (newData, oldExamData) => {
    if (newData.examBegin >= newData.examEnd) {
      toastError('La date et l\'heure de début de l\'examen doivent être avant la date et l\'heure de fin.');
      return;
    }
    semestersList.forEach((sem) => {
      if (newData.semester === sem.value) {
        newData.semester = sem;
      }
    });
    let subject = newData.examSubject;
    if (newData.modality.value !== oldExamData.modality) {
      subjects.forEach((_subject) => {
        if (newData.semester.examType === 1 || newData.semester.examType === 2) {
          if (_subject.type === newData.semester.examType
            && _subject.semester === newData.semester.value
            && isExamUsed(_subject._id) === false) {
            subject = _subject;
          }
        } else if (_subject.type === newData.semester.examType) {
          subject = _subject;
        }
      });
      if (subject === null && withoutSubjectModalities.includes(newData.modality.value) === false) {
        toastError('Plus de sujets disponibles');
        return;
      }
    }

    // let examLvl2Id;
    // if (groups.data) {
    //   const groupsArr = Object.values(groups.data);
    //   groupsArr.forEach((group) => {
    //     if (group.elearning && group.elearning.elearningOptions && group.level === 2) {
    //       group.elearning.elearningOptions.forEach((option) => {
    //         if (option.examBegin === oldExamData.examBegin) {
    //           examLvl2Id = option._id;
    //         }
    //       });
    //     }
    //   });
    // }

    const newDataObj = {
      catchUp: newData.catchUp,
      duration: (newData.modality.value === 'Oral Participation'
        || newData.modality.value === 'Oral - cours en présentiel'
        || newData.modality.value === 'Oral : Role Play'
        || newData.modality.value === 'Oral : Case study'
        || (newData.modality.value === 'Sur la plateforme' && newData.semester.value === 6)
      )
        ? moment(new Date(newData.examEnd)).diff(moment(new Date(newData.examBegin)), 'minutes')
        : newData.duration?.value,
      modality: newData.modality.value,
      EWCorrect: newData.modality.value !== 'Quiz automatisé' ? newData.EWCorrect : false,
      examSubject: withoutSubjectModalities.includes(newData.modality.value) ? null : subject._id,
      examBegin: newData.examBegin,
      examEnd: newData.examEnd,
      deliveryDate: newData.deliveryDate,
      status: {
        name: null,
        createdAt: Date.now(),
        updatedAt: Date.now(),
      },
    };

    if (newData.duration?.value) {
      newDataObj.duration = newData.duration.value;
    }

    elearningDetailsServices.updateElearningOption(oldExamData._id, newDataObj)
      .then(() => {
        updateExamData();
        toastSuccess('Examen modifié avec succès');
      })
      .catch(() => toastError('Problème lors de la mise à jour de l\'examen.'));
  };

  const deleteExam = (oldData) => {
    groupServices.deleteExam(oldData._id)
      .then(() => {
        updateExamData();
        toastSuccess('L\'examen a bien été retiré.');
      })
      .catch(() => toastError('Problème lors de la suppression de l\'examen'));
  };

  return {
    addExam,
    updateExam,
    deleteExam,
  };
};

export default useExam;
